let faq = jQuery('.faq__title a')

faq.on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        thisParent = thisEl.parent()

    thisParent.toggleClass('open').next().slideToggle()

})
